import React from 'react';
import { ActivityEvent, severityStyles } from '../liveTrackingTypes';
import styles from './ActivityFeed.module.css';

interface ActivityFeedProps {
  events: ActivityEvent[];
}

export const ActivityFeed: React.FC<ActivityFeedProps> = ({ events }) => (
  <div className={styles.panel}>
    {events.map((ev, idx) => {
      const s = severityStyles[ev.severity];
      return (
        <div key={idx} className={styles.item}>
          <span className={styles.dot} style={{ background: s.dot }} />
          <div className={styles.content}>
            <p className={styles.message} style={{ color: s.msgColor }}>{ev.message}</p>
          </div>
          <span className={styles.time}>{ev.time}</span>
        </div>
      );
    })}
  </div>
);
